module.exports = __webpack_public_path__ + "img/banner_bg.931c0347.png";